import {useMemo} from 'react';
import {getCandidateSuggestionLabel} from '../selectors';

const useCandidateSuggestionLabel = field => useMemo(() => getCandidateSuggestionLabel(field), [field]);

export default useCandidateSuggestionLabel;
